import { FontAwesome5 } from '@expo/vector-icons';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import * as React from 'react';

import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';
import HomeScreen from '../screens/HomeScreen';
import RoutingScreen from '../screens/RoutingScreen';
import { BottomTabParamList, TabHomeParamList, TabRoutingParamList } from '../types';

const BottomTab = createBottomTabNavigator<BottomTabParamList>();

export default function BottomTabNavigator() {
  const colorScheme = useColorScheme();

  return (
    <BottomTab.Navigator
      initialRouteName="Home"
      tabBarOptions={{ activeTintColor: Colors[colorScheme].tint }}>
      <BottomTab.Screen
        name="Home"
        component={TabHomeNavigator}
        options={{
          tabBarIcon: ({ color }) => <TabBarIcon name="home" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="Routing"
        component={TabRoutingNavigator}
        options={{
          tabBarIcon: ({ color }) => <TabBarIcon name="route" color={color} />,
        }}
      />
    </BottomTab.Navigator>
  );
}

// You can explore the built-in icon families and icons on the web at:
// https://icons.expo.fyi/
function TabBarIcon(props: { name: string; color: string }) {
  return <FontAwesome5 size={30} style={{ marginBottom: -3 }} {...props} />;
}

// Each tab has its own navigation stack, you can read more about this pattern here:
// https://reactnavigation.org/docs/tab-based-navigation#a-stack-navigator-for-each-tab
const TabHomeStack = createStackNavigator<TabHomeParamList>();

function TabHomeNavigator() {
  return (
    <TabHomeStack.Navigator>
      <TabHomeStack.Screen
        name="HomeScreen"
        component={HomeScreen}
        options={{ headerTitle: 'CANTBEFASTER.DE', headerTitleStyle: { fontWeight: 'bold'}  }}
      />
    </TabHomeStack.Navigator>
  );
}

const TabRoutingStack = createStackNavigator<TabRoutingParamList>();

function TabRoutingNavigator() {
  return (
    <TabRoutingStack.Navigator>
      <TabRoutingStack.Screen
        name="RoutingScreen"
        component={RoutingScreen}
        options={{ headerTitle: 'ROUTING', headerTitleStyle: { fontWeight: 'bold'} }}
      />
    </TabRoutingStack.Navigator>
  );
}
